export default {
  isLoginPage: false,   // 需要登入才能訪問的頁面
  isLogoutPage: false,  // 需要登出才能訪問的頁面
  isDevelopmentPage: false, // 需要開發版本才能訪問的頁面
  isScrollRestoration: false, // 自動滾動到history的位置
  liffShowMenu: true, // liff瀏覽器顯示menu
  isNullPage: false // 沒有元件的空白頁面
}
